import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OpeningsComponent } from './views/openings/openings.component';
import { LoginComponent } from './views/login/login.component';
import { AuthGuard } from './services/auth-guard.service';
import { NoPermissionComponent } from './views/no-permission/no-permission.component';
import { DispatchComponent } from './views/dispatch/dispatch.component';
import { KmcComponent } from './views/kmc/kmc.component';
import { UsefulLinksComponent } from './views/useful-links/useful-links.component';
import { DirectoryComponent } from './views/directory/directory.component';
import { RosterComponent } from './views/roster/roster.component';
import { TenThirtythreeHomeComponent } from './views/ten-thirtythree-home/ten-thirtythree-home.component';
import { TenThirtythreeDetailComponent } from './views/ten-thirtythree-detail/ten-thirtythree-detail.component';
import { LiftEvacHomeComponent } from './views/lift-evac-home/lift-evac-home.component';
import { LiftEvacDetailComponent } from './views/lift-evac-detail/lift-evac-detail.component';
import { ReportingComponent } from './views/reporting/reporting.component';
import { JoinComponent } from './views/join/join.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { ForgotPasswordComponent } from './views/forgot-password/forgot-password.component';
import { ExpiredMedsComponent } from './views/expired-meds/expired-meds.component';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'nowhere', canActivate: [ AuthGuard ], component: NoPermissionComponent, data: {title: 'Keystone Ski Patrol'} },
  { path: 'login', component: LoginComponent, data: {title: 'Login'} },
  { path: 'forgot-password', component: ForgotPasswordComponent, data: {title: 'Forgot Password'} },
  { path: 'dispatch', canActivate: [AuthGuard], component: DispatchComponent, data: {title: 'Dispatch'} },
  { path: 'daily/:type/:peak', canActivate: [AuthGuard], component: OpeningsComponent, data: {title: 'Openings/Closings'} },
  { path: 'kmc', canActivate: [AuthGuard], component: KmcComponent, data: {title: 'KMC'} },
  { path: 'useful-links', canActivate: [AuthGuard], component: UsefulLinksComponent, data: {title: 'Useful Links'} },
  { path: 'directory', canActivate: [AuthGuard], component: DirectoryComponent, data: {title: 'Directory'} },
  { path: 'roster', canActivate: [AuthGuard], component: RosterComponent, data: {title: 'Roster'} },
  { path: '1033', canActivate: [AuthGuard], component: TenThirtythreeHomeComponent, data: {title: '10-33'} },
  { path: '1033/:id', canActivate: [AuthGuard], component: TenThirtythreeDetailComponent, data: {title: '10-33'} },
  { path: 'lift-evac', canActivate: [AuthGuard], component: LiftEvacHomeComponent, data: {title: 'Lift Evac'} },
  { path: 'lift-evac/:id', canActivate: [AuthGuard], component: LiftEvacDetailComponent, data: {title: 'Lift Evac'} },
  { path: 'reporting', canActivate: [AuthGuard], component: ReportingComponent, data: {title: 'Reporting'} },
  { path: 'expired-meds', canActivate: [AuthGuard], component: ExpiredMedsComponent, data: {title: 'Expired Meds'} },
  { path: 'join', component: JoinComponent, data: {title: 'Join KSP!'} },
  { path: 'dashboard', canActivate: [AuthGuard], component: DashboardComponent, data: {title: 'Dashboard'} },
  { path: 'weather', canActivate: [AuthGuard], loadChildren: () => import('weather/weather.module').then(m => m.WeatherModule)}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
